import { gql } from '@apollo/client';

export const UPDATE_OBJECT_GROUP_MUTATION = gql`
  mutation UpdateObjectGroupMutation($id: String!, $group: ObjectGroupInput!) {
    updateObjectGroup(id: $id, group: $group) {
      ... on UpdateObjectGroupSuccess {
        group {
          id
          createdAt
          createdBy
          name
          description
          shared
          level
        }
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
`;
